import { useTranslation } from 'react-i18next';
import ExoForm from '../exo/ExoForm';
import InsertInvitationIcon from '@mui/icons-material/InsertInvitation';
import PlaceIcon from '@mui/icons-material/Place';
import FolderIcon from '@mui/icons-material/Folder';
import { API_PATCH, API_POST, DBRequest, useConfig } from '../../api/api';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import moment from 'moment';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';

import AccessTimeIcon from '@mui/icons-material/AccessTime';

export const NewInteraction = ({
  onUpdate,
  onCreate,
  startData,
  onClose,
  onDelete,
  type = '',
  source = null,
  sourceType = null,
  onFeedback,
  textBlockType,
}) => {
  const { t } = useTranslation();
  const config = useConfig();

  const [startDataCollection, setStartDataCollection] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const dateMoment = moment(startData?.dateTime);
    const date = dateMoment.format('YYYY-MM-DD');
    const time = dateMoment.toISOString();

    if (startData && startData.id) {
      showRequest(startData.id);
    } else {
      setStartDataCollection({ ...startData, date, time });
    }
  }, [startData, config]);

  function showRequest(id) {
    DBRequest({
      config,
      path: `interactions/${id}`,
      onLoading: setIsLoading,

      onResponse: (res) => {
        const dateMoment = moment(res.data.dateTime);
        const date = dateMoment.format('YYYY-MM-DD');
        const time = dateMoment.format();

        setStartDataCollection({ ...res.data, date, time });
      },
    });
  }

  const fields = [
    {
      label: t('What') + '?',
      key: 'type',
      type: 'smallIconCards',
      colspan: 2,
      cards: [
        {
          label: t('call'),
          Icon: LocalPhoneIcon,
          value: 'call',
        },
        {
          label: t('Meeting'),
          Icon: InsertInvitationIcon,
          value: 'meeting',
        },
      ],
    },
    {
      label: t('Title'),
      key: 'title',
      type: 'text',
      colspan: 2,
    },

    {
      Icon: InsertInvitationIcon,
      label: t('Date'),
      key: 'date',
      type: 'date',
      size: 'small',
    },
    {
      Icon: AccessTimeIcon,
      label: t('Time'),
      key: 'time',
      type: 'time',
      size: 'small',
    },
    {
      label: t('Duration'),
      key: 'duration',
      type: 'duration',
      size: 'small',
    },

    {
      Icon: PlaceIcon,
      label: t('Address'),
      key: 'address',
      type: 'address',
      size: 'small',
      allowOwnAddress: true,
      suggestionsArr: [
        {
          key: 'participants',
          isArray: true,
          type: 'participant',
        },
      ],
    },
    {
      Icon: FolderIcon,
      label: t('Files'),
      key: 'files',
      type: 'images',
      size: 'small',
      maxItems: 5,
      maxSizeKB: 5000,
    },
    {
      label: t('Private Protocol'),
      key: 'isPrivate',
      type: 'checkbox',
      size: 'small',
    },
    {
      label: t('Project'),
      key: 'project',
      type: 'project',
      colspan: 2,
      apiUrl: 'projects',
    },
    {
      label: t('Note'),
      key: 'note',
      type: 'richTextEditor',
      textBlockType: textBlockType,
      colspan: 2,
    },

    {
      label: t('Participants'),
      key: 'participants',
      type: 'participantsAutoComplete',
      colspan: 2,
      hideEmail: true,
      searchParams: [
        'companies',
        'contacts',
        'person_leads',
        'company_leads',
        'users',
      ],
      size: 'small',
    },
  ];

  function handleSubmit(data) {
    const isUpdate = Boolean(data.id);
    const time = moment(data.time).format('HH:mm');
    const dateTime = moment(
      `${data.date} ${time}`,
      'YYYY-MM-DD HH:mm'
    ).toISOString();

    const reqData = { ...data, dateTime, source, sourceType };

    DBRequest({
      config,
      path: isUpdate ? `interactions/${data.id}` : `interactions`,
      method: isUpdate ? API_PATCH(reqData) : API_POST(reqData),
      onLoading: setIsLoading,
      onFeedback,
      onResponse: (res) => {
        onClose();
        return isUpdate ? onUpdate(res) : onCreate(res);
      },
    });
  }

  const validationSchema = Yup.object().shape({
    date: Yup.string().required(t('Is required')),
    time: Yup.string().required(t('Is required')),
    title: Yup.string().required(t('Is required')),
    type: Yup.string().required(t('Is required')),
    participants: Yup.array()
      .of(
        Yup.object().shape({
          email: Yup.string().nullable(),
          type: Yup.string(),
          participant: Yup.object().shape({
            id: Yup.string(),
          }),
        })
      )
      .min(1)
      .required(t('Is required')),
    address: Yup.object()
      .shape({
        street: Yup.string(),
        houseNumber: Yup.string(),
        zipCode: Yup.string(),
        city: Yup.string(),
        countryCode: Yup.string(),
      })
      .nullable(),
  });

  return (
    <ExoForm
      noDifferences
      startDataCollection={startDataCollection}
      isLoading={isLoading}
      fields={fields}
      header={t('New protocol')}
      onSubmit={handleSubmit}
      className="grid grid-cols-2 gap-4 max-h-full overflow-y-auto pt-2 px-3"
      validationSchema={validationSchema}
      onCancel={onClose}
    />
  );
};
